import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { IonTabBar, IonTabs } from '@ionic/angular/standalone';
import { businessOutline, search } from 'ionicons/icons';

import { AuthenticationService } from '@app/core/services/authentication/authentication.service';
import { CommonModule } from '@angular/common';
import { FreightIconComponent } from '../../../../shared/components/icons/freight-icon/freight-icon.component';
import { HomeIconComponent } from '../../../../shared/components/icons/home-icon/home-icon.component';
import { IonicModule } from '@ionic/angular';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { ROLES as Roles } from '@app/core/utils/roles.enums';
import { TabsAdminComponent } from './components/tabs-admin/tabs-admin.component';
import { TabsCarrierComponent } from './components/tabs-carrier/tabs-carrier.component';
import { TabsCompanyComponent } from './components/tabs-company/tabs-company.component';
import { UserIconComponent } from '../../../../shared/components/icons/user-icon/user-icon.component';
import { addIcons } from 'ionicons';

import { GsapRevealDirective } from '../../../../shared/directives/gsap-reveal.directive';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    UserIconComponent,
    FreightIconComponent,
    HomeIconComponent,
    TabsAdminComponent,
    TabsCarrierComponent,
    TabsCompanyComponent,
    IonTabBar,
    IonTabs,
    GsapRevealDirective,
  ],
})
export class FooterComponent implements OnInit, OnDestroy {
  role!: Roles;
  newNotifications: number = 0;
  roles_enums = Roles;
  private _routerSubscription!: Subscription;

  /**
   * Constructor.
   */
  constructor(
    private authService: AuthenticationService,
    private _notificationService: NotificationService,
    private _router: Router
  ) {
    this.role = this.authService.userRole;
  }

  ngOnInit() {
    addIcons({ businessOutline, search });
    this.invokeReceiveNotification();

    // Listen to navigation changes to refresh the role
    this._routerSubscription = this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.role = this.authService.userRole;
    });
  }

  ngOnDestroy() {
    if (this._routerSubscription) {
      this._routerSubscription.unsubscribe();
    }
  }

  invokeReceiveNotification() {
    this._notificationService
      .onEvent('_ReceiveNotification')
      .subscribe((notification) => {
        this.updateNotificationsNumber();
      });
  }

  private updateNotificationsNumber() {
    this.newNotifications++;
  }
}
